import { IQuestionModel } from '@care-portals/api-interfaces';

const options = [
  { key: '0', value: 'Not at all' },
  { key: '1', value: 'Somewhat' },
  { key: '2', value: 'Moderately' },
  { key: '3', value: 'A lot' },
  { key: '4', value: 'Extremely' }
];

const questions = [
  [
    'depression',
    'How depressed do you feel right now?',
    [
      'Sad or down in the dumps',
      'Discouraged or hopeless',
      'Low self-esteem, inferiority, worthlessness',
      'Loss of motivation to do things',
      'Loss of pleasure or satisfaction in life'
    ]
  ],
  [
    'suicidal_urges',
    'Suicidal urges: Do you sometimes',
    [
      'Feel like you’d be better off dead?',
      'Have suicidal thoughts or fantasies?',
      'Have urges or plans to end your life?'
    ]
  ],
  [
    'anxiety',
    'How anxious do you feel right now?',
    [
      'Anxious',
      'Frightened',
      'Worrying about things',
      'Tense or on edge',
      'Nervous'
    ]
  ],
  [
    'anger',
    'How angry do you feel right now?',
    ['Frustrated', 'Annoyed', 'Resentful', 'Angry', 'Irritated']
  ],
  [
    'happiness',
    'How happy do you feel right now?',
    [
      'Happy and joyful',
      'Hopeful and optimistic',
      'Worthwhile, high self-esteem',
      'Motivated, productive',
      'Pleasure and satisfaction in life'
    ]
  ],
  [
    'relationship',
    'Relationship Satisfaction',
    'Put the name of an important relationship in your life:',
    [
      'Communication and openness',
      'Resolving conflicts',
      'Degree of affection and caring',
      'Intimacy and closeness',
      'Overall satisfaction'
    ]
  ]
];

let n = 1;

const questionsModels: IQuestionModel[] = [
  {
    field: 'bms_before_intro',
    type: 'info',
    label: 'Please complete the following surveys BEFORE the session.',
    answer: {}
  },
  ...questions.map(([name, label, ...qs]) => {
    const section: IQuestionModel = {
      label: label as string,
      subLabel: '',
      field: `bms_${name as string}`,
      type: 'info',
      answer: {
        type: 'list',
        items: []
      }
    };

    qs.forEach(q => {
      if (typeof q === 'string') {
        section.answer.items.push({
          label: q,
          type: 'text',
          name: `bms_${name}_${n++}`
        });
      } else {
        section.answer.items.push(
          ...q.map(qq => ({
            label: qq,
            type: 'single_select',
            level: 'child',
            field: `bms_${name}_${n++}`,
            options: options.map(({key, value}, i) => ({key: `bms_${name}_${n}_${i}`, value}))
          }))
        );
      }
    });
    return section;
  }),
  {
    field: `bms_homework`,
    label:
      'How much psychotherapy homework have you done since your last session?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '0', value: 'None' },
        { key: '1', value: 'A little' },
        { key: '2', value: 'A moderate amount' },
        { key: '3', value: 'A lot' }
      ]
    }
  }
];

export default questionsModels;
